import slick from '@accessible360/accessible-slick';
import $ from 'jQuery';

export default function () {
	$(function() {
		honoree_spotlight_sliders_init();
    honoree_spotlight_modals();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class Slider {
    /**
     * Slider Constructor
     * @param {HTML Element} element Element to transform into a slick slider.
     * @param {object} options Optional settings to overwrite the defaults.
     */
     constructor(element, options) {
      // Grabs reference to the passed in element.
      this.element = element;

      // We can pass in alternate options to overwrite the defaults.
      this.settings = { ...slickDefaults, ...options };

      // Sets a slider variable from the returned slick slider instance built.
      this.slider = this.build();

      // Calls a utility ready function when everything is done.
      this.ready();
    }

    /**
     * Builds out a slick slider from the element and the settings.
     * @returns jQuery Element
     */
    build() {
    	return $(this.element).slick(this.settings);
    }

    /**
     * Utility function to add a ready class to the element.
     */
    ready() {
     	this.element.classList.add('ready');
    }
  }

  const $carousel = $('.block--honoree-spotlight');

  function honoree_spotlight_sliders_init() {
   	if ($carousel.length) {

      // First slider
      $('.honoree-spotlight--top--items', $carousel).each(function() {
        let $thisSlider = $(this);
        let el = $thisSlider[0];
        const $sliderContainer = $thisSlider.parents('.honoree-spotlight--top');

        const slickSettings = {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          speed: 1000,
          fade: true,
          dots: true,
          asNavFor: '.honoree-spotlight--bottom--items',
        }

        $thisSlider.on('init', function(e, slider) {
          $(this).find('.slick-dots button').attr('tabindex','-1');
        });

        if (!el.Slider) {
          el.Slider = new Slider(el, slickSettings);
        }
      });

      // Names slider
      $('.honoree-spotlight--bottom--items', $carousel).each(function() {
        let $thisSlider = $(this);
        let el = $thisSlider[0];
        const $sliderContainer = $thisSlider.parents('.honoree-spotlight--bottom');

        const slickSettings = {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          speed: 1000,
          asNavFor: '.honoree-spotlight--top--items',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 1,
              }
            },
          ]
        }

        if (!el.Slider) {
          el.Slider = new Slider(el, slickSettings);
        }
      });
   	}

    $('.honoree-spotlight--bottom--item').on('click', function(evt) {
      evt.preventDefault();
      var $indexPlusOne = $(this).parents('.slick-slide').attr('aria-label').replace('slide ', '');
      $('.honoree-spotlight--top .slick-dots li:nth-child('+$indexPlusOne+') button').trigger('click');
    });
  }

  function honoree_spotlight_modal_slider_init() {
    if ($carousel.length) {
      // Modal Slider
      var $pagerContainer = $('.honoree-spotlight--modal .slider--controls__pagination');
      var $prevButton = $('.honoree-spotlight--modal .slider--arrow--prev');
      var $nextButton = $('.honoree-spotlight--modal .slider--arrow--next');

      $('.honoree-spotlight--modal--items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 1000,
        dots: true,
        asNavFor: '.honoree-spotlight--top--items, .honoree-spotlight--bottom--items',
        fade: true,
        arrowsPlacement: 'afterSlides',
        prevArrow: $prevButton,
        nextArrow: $nextButton,
        appendDots: $pagerContainer,
        dotsClass: 'slick--pagination', // Slick generates a <ul.carousel-pagination> within the appendDots container
        customPaging: function (slider, i) {
          const slideNumber = (i + 1);
          const totalSlides = slider.slideCount;
          return '<button class="pagination-control" tabindex="-1"><span class="visually-hidden">View slide ' + slideNumber + ' of ' + totalSlides + '</span></button>';
        },
      });
    }
  }

  function honoree_spotlight_modals() {
    // open story modal slider - builds slider
    $('.honoree-spotlight--top').on('click', '.see-story', function(evt) {
      evt.preventDefault();

      var $indexPlusOneModal = $(this).parents('.slick-slide').attr('aria-label').replace('slide ', '');

      $('.honoree-spotlight--modal.story-modal').show();
      $('html').addClass('modal-is-open');

      setTimeout(function() {
		$('.honoree-spotlight--modal.story-modal').addClass('active');
		$('.honoree-spotlight--modal--slidable').animate({
		  scrollTop: 0
		}, 0); // set to 0 to make it instant, otherwise 'fast', 'slow', '5000', etc. work
	  }, 100);

      honoree_spotlight_modal_slider_init();
      $('.honoree-spotlight--modal--controls .slick--pagination li:nth-child('+$indexPlusOneModal+') button').trigger('click');

      setTimeout(function() {
        $('.honoree-spotlight--modal--slidable').addClass('active');
      }, 200);
    });

    // close sotry modal slider - reset to original markup
    $('html').on('click', '#honoreeModalClose', function(evt) {
      evt.preventDefault();
      $('.honoree-spotlight--modal--slidable').removeClass('active');

      setTimeout(function() {
        $('.honoree-spotlight--modal.story-modal').removeClass('active');
      }, 100);

      setTimeout(function() {
        $('.honoree-spotlight--modal.story-modal')
          .hide()
          .find('.slick--pagination').remove();

        $('.honoree-spotlight--modal--items')
          .removeClass('slick-initialized slick-slider slick-dotted ready')
          .attr('role', '')
          .attr('aria-label', '');

        $('.honoree-spotlight--modal--item')
          .unwrap()
          .unwrap()
          .unwrap()
          .unwrap()
          .attr('style','');

        $('html').removeClass('modal-is-open');
      }, 200);
    });

    $('html').on('click', '.honoree-spotlight--top--item .play-video', function(evt) {
      evt.preventDefault();

      var $parent = $(this).parents('.honoree-spotlight--top--item');
      var $modal = $parent.find('.honoree-spotlight--modal.video-modal');

      $modal.show();
      $('html').addClass('modal-is-open');

      setTimeout(function() {
        $modal.addClass('active');
      }, 100);
    });

    $('html').on('click', '#videoModalClose', function(evt) {
      evt.preventDefault();

      $('.honoree-spotlight--modal.video-modal').removeClass('active')

      setTimeout(function() {
        $('.honoree-spotlight--modal.video-modal').hide();
        $('html').removeClass('modal-is-open');
      }, 300);
    });
  }
}
